module.exports = __webpack_public_path__ + "img/top.b69129f4.png";